import {Component} from '@angular/core';
import {EditDialogComponent} from "../edit-dialog/edit-dialog.component";
import {ColDef, ColType} from "../../interfaces/colDef";
import {Globals} from "../../shared/Globals";

@Component({
    selector: 'bst-filter-dialog',
    templateUrl: './filter-dialog.component.html',
    styleUrls: ['../edit-dialog/edit-dialog.component.scss', './filter-dialog.component.scss'],
    standalone: false
})
export class FilterDialogComponent extends EditDialogComponent<any>{

  async ngOnInit(): Promise<void> {
    const items = {};
    this.description.forEach((col: ColDef) => {
      const validators = [];
      if(col.type === ColType.RANGE){
        items[col.name] = [this.data && this.data[col.name] && (this.data[col.name].lte || this.data[col.name].gte) ? {
          start: this.data[col.name].gte,
          end: this.data[col.name].lte
        } : null, validators];
      }
      else if(col.type === ColType.DATE){
        items[col.name + '_start'] = [Globals.fromDateString(this.data && this.data[col.name] ? this.data[col.name].gte || null : null), validators];
        items[col.name + '_end'] = [Globals.fromDateString(this.data && this.data[col.name] ? this.data[col.name].lte || null : null), validators];
      }
      else {
        items[col.name] = [this.data ? this.data[col.name] : null, validators];
      }
    });

    this.form = this.fb.group(items);
  }

  submit() {
    const val = this.form;
    const result = {};
    this.description.forEach((col: ColDef) => {
      if(col.type === ColType.LISTADDER){
        const v = val.get(col.name).value;
        result[col.name] = (!v || !v.length) ? null : v;
      }
      else if(col.type === ColType.RANGE){
        const a = val.get(col.name).value;
        if(a && (a.start || a.end)){
          result[col.name] = {
            gte: Globals.toISODate(a.start),
            lte: Globals.toISODate(a.end)
          };
        }
        else{
          result[col.name] = null;
        }
      }
      else if(col.type === ColType.DATE) {
        const a = val.get(col.name + '_start').value;
        const b = val.get(col.name + '_end').value;
        if(a || b) {
          result[col.name] = {
            gte: Globals.toISODate(a),
            lte: Globals.toISODate(b)
          };
        }
        else{
          result[col.name] = null;
        }
      }
      else {
        const v = val.get(col.name).value;
        if(typeof v === 'undefined' || v === ""){
          result[col.name] = null;
        }
        else{
          result[col.name] = v;
        }
      }
    });

    this.ref.close(result);
  }

  filtername(col: ColDef){
    return typeof col.filter === 'string' ? col.filter : col.name;
  }

  clear() {
    const result = {};
    this.description.forEach((col: ColDef) => {
      result[col.name] = null;
    });
    this.ref.close(result);
  }
}
